// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"168":"af59542f559733dd2490","603":"9e6301b3a893df274dd6","854":"06b33ded2f910ec0bcd6","956":"b2f2b6052c2ec8e1b399"}[chunkId] + ".chunk.js";
};